import * as React from "react";
const SvgCameraIcon = (props) => /* @__PURE__ */ React.createElement("svg", {
	width: 36,
	height: 36,
	viewBox: "0 0 36 36",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...props
}, /* @__PURE__ */ React.createElement("g", { clipPath: "url(#clip0_11623_629154)" }, /* @__PURE__ */ React.createElement("rect", {
	width: 36,
	height: 36,
	rx: 8,
	fill: "#E8FAEB"
}), /* @__PURE__ */ React.createElement("path", {
	fillRule: "evenodd",
	clipRule: "evenodd",
	d: "M21.372 12.5556H10.628C9.90231 12.5556 9.31401 13.252 9.31401 14.1111V21.8889C9.31401 22.748 9.90231 23.4444 10.628 23.4444H21.372C22.0977 23.4444 22.686 22.748 22.686 21.8889V14.1111C22.686 13.252 22.0977 12.5556 21.372 12.5556ZM10.628 11C9.1766 11 8 12.3929 8 14.1111V21.8889C8 23.6071 9.1766 25 10.628 25H21.372C22.8234 25 24 23.6071 24 21.8889V14.1111C24 12.3929 22.8234 11 21.372 11H10.628Z",
	fill: "#26CD58"
}), /* @__PURE__ */ React.createElement("path", {
	fillRule: "evenodd",
	clipRule: "evenodd",
	d: "M26.7152 14.7117C26.7152 14.5282 26.5443 14.4103 26.4016 14.4953L23.4016 16.2834C23.3309 16.3255 23.2867 16.4089 23.2867 16.4998V19.5855C23.2867 19.6781 23.3326 19.7627 23.4054 19.804L26.4054 21.507C26.5479 21.5879 26.7152 21.4698 26.7152 21.2884V14.7117ZM25.8057 13.197C26.8044 12.6017 28.0009 13.4273 28.0009 14.7117V21.2884C28.0009 22.558 26.8293 23.3846 25.8321 22.8185L22.8321 21.1155C22.3228 20.8264 24.0021 20.5 23.0009 19.5855V16.4998C24.002 15 22.311 15.28 22.8057 14.9851L25.8057 13.197Z",
	fill: "#26CD58"
})), /* @__PURE__ */ React.createElement("defs", null, /* @__PURE__ */ React.createElement("clipPath", { id: "clip0_11623_629154" }, /* @__PURE__ */ React.createElement("rect", {
	width: 36,
	height: 36,
	fill: "white"
}))));
export default SvgCameraIcon;
